import { defineStore } from "pinia";
import { ref, computed } from "vue";
import api from "../services/api";

export const useAuthStore = defineStore("auth", () => {
  const user = ref(null);
  const loading = ref(false);

  const isAuthenticated = computed(() => !!user.value);
  const isSubscribed = computed(
    () =>
      user.value?.isAdmin === true ||
      user.value?.isAdmin === 1 ||
      user.value?.subscription?.status === "active" ||
      user.value?.subscription?.status === "trialing"
  );
  const subscription = computed(() => user.value?.subscription || null);

  async function init() {
    const token = localStorage.getItem("accessToken");
    if (!token) return;
    try {
      const { data } = await api.get("/auth");
      user.value = data.user;
    } catch {
      /* silent */
    }
  }

  async function register(payload) {
    loading.value = true;
    try {
      const { data } = await api.post("/auth", {
        action: "register",
        ...payload,
      });
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      user.value = data.user;
      await refreshUser();
      return data;
    } finally {
      loading.value = false;
    }
  }

  async function login(payload) {
    loading.value = true;
    try {
      const { data } = await api.post("/auth", { action: "login", ...payload });
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      user.value = data.user;
      // Fetch full user profile (includes isAdmin, subscription)
      await refreshUser();
      return data;
    } finally {
      loading.value = false;
    }
  }

async function loginWithGoogle(credential) {
    loading.value = true;
    try {
      const { data } = await api.post("/auth/google", { credential });
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      user.value = data.user;
      await refreshUser();
      return data;
    } finally {
      loading.value = false;
    }
  }

  async function loginWithApple(idToken, userInfo) {
    loading.value = true;
    try {
      const { data } = await api.post("/auth/apple", { idToken, user: userInfo });
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      user.value = data.user;
      await refreshUser();
      return data;
    } finally {
      loading.value = false;
    }
  }

  async function forgotPassword(email) {
    const { data } = await api.post("/auth", {
      action: "forgot-password",
      email,
    });
    return data;
  }

  async function resetPassword(token, password) {
    const { data } = await api.post("/auth", {
      action: "reset-password",
      token,
      password,
    });
    return data;
  }

  function logout() {
    user.value = null;
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }

async function refreshUser() {
  try {
    const { data } = await api.get("/auth");
    console.log("refreshUser response:", JSON.stringify(data.user));
    user.value = data.user;
  } catch {
    /* silent */
  }
}

  return {
    user,
    loading,
    isAuthenticated,
    isSubscribed,
    subscription,
    init,
    register,
    login,
    loginWithGoogle,
    loginWithApple,
    forgotPassword,
    resetPassword,
    logout,
    refreshUser,
  };
});
